<template>
    <div class="con">
        <!-- 商家首页页面 -->
        <div class="coninner">
            <div class="contop">
                <div class="userAvatar">
                    <img :src="$img(info.avatar)" v-if="info.avatar" alt="" />
                    <img :src="$Localimg('defaultAvatar.png')" v-else alt="" />
                </div>
                <div class="userName" v-text="info.nickname">
                </div>
            </div>
            <!--  style=" width: 1200px;" -->
            <div class="cDetail flx jsb">
                <!--  style="width: 200px;height: 400px;" -->
                <div class="cdLeft">
                    <div class="clItem" style="height: 52px;" :class="cur == 0?'active':''" @click="changeTab(0)">
                        <div class="shu" v-if="cur == 0"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index1.png')" alt="" />
                            </div>
                            <div class="cName">
                                首页
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 1?'active':''" @click="changeTab(1)">
                        <div class="shu" v-if="cur == 1"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index2.png')" alt="" />
                            </div>
                            <div class="cName" style="position: relative;">
                                <div class="redpoint" v-if="info.activity_red_num > 0"></div>
                                活动管理
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 2?'active':''" @click="changeTab(2)">
                        <div class="shu" v-if="cur == 2"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index3.png')" alt="" />
                            </div>
                            <div class="cName" style="position: relative;">
                                <div class="redpoint" v-if="info.job_red_num > 0"></div>
                                职位管理
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 3?'active':''" v-if="info.fwcg_status == 1"
                        @click="changeTab(3)">
                        <div class="shu" v-if="cur == 3"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index4.png')" alt="" />
                            </div>
                            <div class="cName" style="position: relative;">
                                <div class="redpoint" v-if="info.fwcg_red_num > 0"></div>
                                服务采购管理
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 4?'active':''" @click="changeTab(4)">
                        <div class="shu" v-if="cur == 4"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index5.png')" alt="" />
                            </div>
                            <div class="cName">
                                企业信息
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 5?'active':''" @click="changeTab(5)">
                        <div class="shu" v-if="cur == 5"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index6.png')" alt="" />
                            </div>
                            <div class="cName">
                                短信通知
                            </div>
                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 7?'active':''" @click="changeTab(7)">
                        <div class="shu" v-if="cur == 7"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index6.png')" alt="" />
                            </div>
                            <div class="cName" style="position: relative;">
                                <div class="redpoint" v-if="info.systemnotice_red_num > 0"></div>
                                我的消息
                            </div>

                        </div>
                    </div>

                    <div class="clItem" style="height: 52px;" :class="cur == 6?'active':''" @click="changeTab(6)">
                        <div class="shu" v-if="cur == 6"></div>
                        <div class="cItemInner">
                            <div class="cIcon">
                                <img :src="$Localimg('index7.png')" alt="" />
                            </div>
                            <div class="cName">
                                账号设置
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cdRight">
                    <shops @toConfirm="toConfirm" @changes="changesTab" v-if="cur == 0"></shops>
                    <Activity @rfh="rfhs" v-if="cur == 1"></Activity>
                    <Zp @rfh="rfhs" v-if="cur == 2"></Zp>
                    <Service @rfh="rfhs" v-if="cur == 3"></Service>
                    <Company v-if="cur == 4"></Company>
                    <Mine @rfh="rfhs" v-if="cur == 6"></Mine>
                    <shortMessage @toConfirm="toConfirm" :showincharge="smshow" v-if="cur == 5"></shortMessage>
                    <Message @rfh="rfhs" v-if="cur == 7"></Message>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        shoUserInfo
    } from "@/api/index.js"
    import shops from './shop.vue'
    import Activity from '../activity/activity.vue'
    import Zp from '../zp/zp.vue'
    import Service from "../service/service.vue"
    import Company from "../company/company.vue"
    import Mine from "../shop/mine.vue"
    import shortMessage from './shortmessage.vue'
    import Message from './message.vue'
    export default {
        components: {
            shops,
            Activity,
            Zp,
            Service,
            Company,
            Mine,
            shortMessage,
            Message
        },
        name: 'Shop',
        data() {
            return {
                cur: 0,
                info: {},
                smshow:false
            }
        },
        created() {
            let that = this
            let timer = setInterval(() => {
                let token = localStorage.getItem("shop_token")
                if (token) {
                    this.getUser()
                    window.clearInterval(timer)
                }
            }, 1000)
        },
        activated() {
            this.getUser()
            if (this.$route.query.id == 0) {
                this.cur = 5
                this.$router.push({
                    params: {
                        id: ''
                    }
                })
            }
        },
        methods: {
            changesTab(e) {
                let that = this
                console.log(e)
                if (e == 0) {
                    that.cur = 5
                    that.smshow = true
                }
            },
            rfhs() {
                this.getUser()
            },
            changeTab(e) {
                let that = this
                that.cur = e
            },
            toConfirm() {
                this.$router.push('/verify')
            },
            getUser() {
                let that = this
                shoUserInfo().then((res) => {
                    console.log("user", res)
                    if (res.code == 1) {
                        that.info = res.data
                    }else if(res.code == -4){
                        this.$router.push('/verify')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .redpoint {
        width: 5px;
        height: 5px;
        background: red;
        border-radius: 50%;
        position: absolute;
        top: 4px;
        right: -12px;
    }

    .clItem:hover {
        background: rgba(0, 122, 255, 0.07) !important;
        cursor: pointer;
    }

    .active {
        background: rgba(0, 122, 255, 0.07) !important;
    }

    .shu {
        height: 52px;
        width: 4px;
        background: #007AFF;
        position: absolute;
        left: 0;
        top: 0;
        flex-shrink: 0;
    }

    .cIcon {
        width: 20px;
        height: 20px;
        margin-right: 6px;
    }

    .cName {
        font-size: 14px;
        color: #333333;
    }

    .cIcon img {
        width: 100%;
        height: 100%;
    }

    .cItemInner {
        display: flex;
        box-sizing: border-box;
        padding-left: 20px;
        align-items: center;
    }

    .clItem {
        display: flex;
        position: relative;
    }

    .cdRight {
        width: 968px;
        background: #fff;
        border-radius: 10px;
    }

    .cdLeft {
        width: 200px;
        background: #fff;
        padding: 32px 0;
        border-radius: 10px;
        flex-shrink: 0;
        margin-right: 14px;
        display: inline-block;
        min-height: 428px;
    }

    .cDetail {
        width: 1200px;
        position: relative;
        top: -40px;
        margin: 0 auto;
        display: flex;
        align-items: flex-start;
    }

    .userAvatar {
        box-sizing: border-box;
        padding: 20px 0 12px;
        text-align: center;
    }

    .userAvatar img {
        width: 66px;
        height: 66px;
        border-radius: 50%;
        object-fit: cover;
    }

    .coninner {
        position: relative;
        background: #f8f8f8;
        /* height: 50vh; */
    }

    .contop {
        height: 180px;
        width: 100%;
        background: url('https://two.hrxsl.com/pcImages/indexBk.png') no-repeat;
        background-size: 100% auto;
    }

    .userName {
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
    }
</style>